import { BrowserRouter, Routes, Route, useNavigate, useParams } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import EpisodePage from './pages/EpisodePage';
import AllEpisodesPage from './pages/AllEpisodesPage';
import NewsPage from './pages/NewsPage';
import NewsArticlePage from './pages/NewsArticlePage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import { AdminAuthProvider, useAdminAuth } from './contexts/AdminAuthContext';

function AdminRoute() {
  const { user, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-yellow-400 font-horizon text-2xl animate-pulse">Loading...</div>
      </div>
    );
  }

  return user ? <AdminDashboardPage /> : <AdminLoginPage />;
}

function HomePageWrapper() {
  const navigate = useNavigate();
  return (
    <>
      <Header onNavigateToAdmin={() => navigate('/admin')} onNavigateToAllEpisodes={() => navigate('/episodes')} />
      <main className="pt-16">
        <HomePage
          onNavigateToEpisode={(slug) => navigate(`/episodes/${slug}`)}
          onNavigateToAllEpisodes={() => navigate('/episodes')}
          onNavigateToNews={() => navigate('/news')}
          onNavigateToNewsArticle={(id) => navigate(`/news/${id}`)}
        />
      </main>
      <Footer />
    </>
  );
}

function EpisodePageWrapper() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  return <EpisodePage slug={slug || ''} onBack={() => navigate('/')} />;
}

function AllEpisodesPageWrapper() {
  const navigate = useNavigate();
  return <AllEpisodesPage onNavigateToEpisode={(slug) => navigate(`/episodes/${slug}`)} onBack={() => navigate('/')} />;
}

function NewsPageWrapper() {
  const navigate = useNavigate();
  return (
    <>
      <div className="fixed top-4 right-4 z-50">
        <button
          onClick={() => navigate('/')}
          className="bg-[#ffed00] text-black px-6 py-3 font-bold hover:bg-[#ffed00]/90 transition-colors"
        >
          Back to Home
        </button>
      </div>
      <NewsPage onNavigateToArticle={(id) => navigate(`/news/${id}`)} onBack={() => navigate('/')} />
    </>
  );
}

function NewsArticlePageWrapper() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  return (
    <>
      <div className="fixed top-4 right-4 z-50">
        <button
          onClick={() => navigate('/')}
          className="bg-[#ffed00] text-black px-6 py-3 font-bold hover:bg-[#ffed00]/90 transition-colors"
        >
          Back to Home
        </button>
      </div>
      <NewsArticlePage id={id || ''} onBack={() => navigate('/news')} />
    </>
  );
}

function App() {
  return (
    <AdminAuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-black">
          <Routes>
            <Route path="/" element={<HomePageWrapper />} />
            <Route path="/episodes" element={<AllEpisodesPageWrapper />} />
            <Route path="/episodes/:slug" element={<EpisodePageWrapper />} />
            <Route path="/news" element={<NewsPageWrapper />} />
            <Route path="/news/:id" element={<NewsArticlePageWrapper />} />
            <Route path="/admin" element={<AdminRoute />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AdminAuthProvider>
  );
}

export default App;
